// Types d'erreurs possibles
export type ErrorType = 'auth' | 'database' | 'storage' | 'network' | 'validation' | 'unknown';

// Interface pour les erreurs structurées
interface ErrorLog {
  type: ErrorType;
  message: string;
  code?: string;
  details?: unknown;
  timestamp: string;
}

// En production, on pourrait envoyer les logs à un service comme Sentry
const isProd = process.env.NODE_ENV === 'production';

/**
 * Logger pour gérer les erreurs de manière centralisée
 */
export const logger = {
  error: (type: ErrorType, message: string, details?: unknown) => {
    const errorLog: ErrorLog = {
      type,
      message,
      details,
      timestamp: new Date().toISOString(),
    };

    // En production, on pourrait envoyer à un service de monitoring
    if (isProd) {
      // Ici, on pourrait intégrer Sentry ou un autre service
      // Sentry.captureException(new Error(message), { extra: errorLog });
    } else {
      // En développement, on affiche dans la console
      console.error('[ERROR]', errorLog);
    }

    return message; // Retourne le message pour l'affichage à l'utilisateur
  },

  // Pour les messages de debug en développement uniquement
  debug: (message: string, data?: unknown) => {
    if (!isProd) {
      console.log('[DEBUG]', message, data);
    }
  }
};

/**
 * Fonction utilitaire pour formater les erreurs Firebase
 */
export const formatFirebaseError = (error: any): string => {
  if (!error?.code) return 'Une erreur inattendue est survenue';

  switch (error.code) {
    case 'auth/email-already-in-use':
      return 'Cette adresse email est déjà utilisée';
    case 'auth/invalid-email':
      return 'L\'adresse email n\'est pas valide';
    case 'auth/weak-password':
      return 'Le mot de passe doit contenir au moins 6 caractères';
    case 'auth/user-not-found':
    case 'auth/wrong-password':
      return 'Email ou mot de passe incorrect';
    case 'storage/quota-exceeded':
      return 'La limite de stockage a été atteinte';
    case 'storage/unauthorized':
      return 'Vous n\'avez pas les droits nécessaires pour effectuer cette action';
    default:
      return 'Une erreur est survenue';
  }
};
